import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Acasa from './pagini/Acasa';
import Navbar from './componente/Navbar';
import Logare from './pagini/Logare';
import Inregistrare from './pagini/Inregistrare';
import AdaugaAnunt from './pagini/AdaugaAnunt';
import DetaliiAnunt from './pagini/DetaliiAnunt';
import Profil from './pagini/Profil';
import Eroare404 from './pagini/Eroare404';
import AnunturileMele from './pagini/AnunturileMele';
import Comenzi from './pagini/Comenzi';
import Mesaje from './pagini/Mesaje';
import Favorite from './pagini/Favorite';
import Alerte from './pagini/Alerte';
import Setari from './pagini/Setari';
import EditeazaAnunt from './pagini/EditeazaAnunt';
import Cautare from './pagini/Cautare';
import Admin from './pagini/Admin';
import PaginaText from './pagini/PaginaText';
import Ajutor from './pagini/Ajutor';

function App() {
  return (
    <Router>
      <Navbar />
      <Toaster position="bottom-right" />
      <Routes>

        <Route path="/" element={<Acasa />} />
        <Route path="/logare" element={<Logare />} />
        <Route path="/inregistrare" element={<Inregistrare />} />
        <Route path="/adauga-anunt" element={<AdaugaAnunt />} />
        <Route path="/anunt/:id" element={<DetaliiAnunt />} />
        <Route path="/profil" element={<Profil />} />
        <Route path="/anunturile-mele" element={<AnunturileMele />} />
        <Route path="/comenzi" element={<Comenzi />} />
        <Route path="/mesaje" element={<Mesaje />} />
        <Route path="/favorite" element={<Favorite />} />
        <Route path="/alerte" element={<Alerte />} />
        <Route path="/setari" element={<Setari />} />
        <Route path="/editeaza-anunt/:id" element={<EditeazaAnunt />} />
        <Route path="/cautare" element={<Cautare />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/ajutor" element={<Ajutor />} />

        <Route
          path="/cum-functioneaza"
          element={
            <PaginaText
              titlu="Cum functioneaza Tranzitio?"
              continut={`Platforma noastra este construita pentru a face tranzactiile cat mai simple si sigure:
                        1. Crearea contului: Te inregistrezi gratuit folosind adresa de email.
                        2. Publicarea: Adaugi un anunt clar, cu descriere si poze reale ale produsului.
                        3. Comunicarea: Folosesti sistemul nostru de chat in timp real pentru a discuta detaliile cu persoanele interesate, fara a fi nevoie sa iti dai numarul de telefon daca nu doresti.
                        4. Tranzactia: Dupa ce cadeti de acord, finalizati tranzactia offline sau prin metodele stabilite in chat.
                        5. Recenzia: Dupa apasarea butonului "Cumpara Acum", cumparatorul poate lasa o recenzie (stele si comentariu) pentru a ajuta comunitatea sa identifice vanzatorii de incredere.`}
            />
          }
        />

        <Route
          path="/reguli"
          element={
            <PaginaText
              titlu="Reguli de publicare"
              continut={`Pentru a mentine un mediu curat si sigur pentru toti utilizatorii, aplicam urmatoarele reguli stricte:
                        - Sunt interzise anunturile care promoveaza produse ilegale, periculoase, furate sau contrafacute.
                        - Titlul si descrierea anuntului trebuie sa reflecte cu exactitate produsul sau serviciul oferit. Nu este permis "clickbait-ul".
                        - Imaginile incarcate trebuie sa fie reale si sa prezinte starea actuala a produsului. Imaginile preluate de pe internet vor duce la stergerea anuntului.
                        - In cadrul sistemului de mesagerie, este interzis limbajul vulgar, jignirile, spam-ul sau tentativele de frauda.
                        - Utilizatorii care incalca aceste reguli in mod repetat vor avea conturile suspendate definitiv de catre administratori.`}
            />
          }
        />

        <Route
          path="/contact"
          element={
            <PaginaText
              titlu="Contacteaza-ne"
              continut={`Echipa Tranzitio este intotdeauna gata sa te ajute. Daca ai intampinat o problema tehnica, ai o sugestie de imbunatatire a platformei sau vrei sa raportezi o neregula, ne poti gasi aici:
                          Suport Tehnic:
                          - Email: suport@tranzitio.ro
                          - Vom raspunde solicitarilor in maximum 24 de ore lucratoare.

                          Detalii Proiect:
                          - Dezvoltator: Andrei Badea
                          - Scop: Lucrare de Licenta
                          - Tehnologii folosite: MERN Stack (MongoDB, Express, React, Node.js), Socket.io, JWT.`}
            />
          }
        />

        <Route
          path="/termeni"
          element={
            <PaginaText
              titlu="Termeni si Conditii"
              continut={`Prin accesarea si utilizarea platformei Tranzitio, accepti urmatorii termeni:
                        1. Rolul platformei: Tranzitio functioneaza exclusiv ca un intermediar digital, oferind spatiul tehnic pentru ca vanzatorii si cumparatorii sa poata interactiona.
                        2. Responsabilitate: Nu ne asumam responsabilitatea pentru calitatea, siguranta sau legalitatea produselor listate de catre utilizatori. Responsabilitatea tranzactiei finale apartine in totalitate utilizatorilor implicati.
                        3. Drepturi de proprietate: Continutul incarcat de utilizatori (texte, imagini) ramane proprietatea acestora, dar ne acorda dreptul de a-l afisa public pe platforma.
                        4. Modificari: Ne rezervam dreptul de a modifica acesti termeni, actualizand aceasta pagina ori de cate ori este necesar.`}
            />
          }
        />

        <Route
          path="/confidentialitate"
          element={
            <PaginaText
              titlu="Politica de Confidentialitate"
              continut={`Protejarea datelor tale personale este o prioritate absoluta pentru noi.
                        Ce date colectam:
                        - Colectam doar informatiile minime necesare functionarii platformei (nume, adresa de email si, optional, numarul de telefon).

                        Cum iti protejam datele:
                        - Parolele nu sunt stocate niciodata in format text simplu in baza de date. Ele sunt criptate folosind algoritmul bcrypt.
                        - Comunicarea dintre browser-ul tau si server este securizata prin HTTPS.
                        - Autentificarea se face pe baza de token-uri JWT care expira automat.

                        Nu vindem si nu vom vinde niciodata datele tale personale catre companii de marketing sau terti.`}
            />
          }
        />

        <Route path="*" element={<Eroare404 />} />

      </Routes>
    </Router>
  );
}

export default App;